import { render, staticRenderFns } from "./AdminSummary.vue?vue&type=template&id=20d038b5"
import script from "./AdminSummary.vue?vue&type=script&lang=js"
export * from "./AdminSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports